export default function porBannersReducer(
  state = {
    data: [],
    fetching: false,
    fetched: false,
  },
  action
) {
  switch (action.type) {
    case 'GET_POR_BANNERS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case 'GET_POR_BANNERS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payLoad.data
      };
    }
    case 'GET_POR_BANNERS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors,
      };
    }
    case 'CLEAR_POR_BANNERS': {
      return {
        ...state,
        data: []
      };
    }
    default:
  }

  return { ...state };
}
